import i18n from "../i18/i18n";

export const te = (errorCode) => {
  return i18n.t(`errors.${errorCode}`);
};
